export const COCKPIT_HOST = process.env.COCKPIT_HOST;
export const COCKPIT_STORAGE_DIR = process.env.COCKPIT_STORAGE_DIR;
export const COCKPIT_UPLOADS_DIR = process.env.COCKPIT_UPLOADS_DIR;
export const COCKPIT_API_TOKEN = process.env.COCKPIT_API_TOKEN;
export const COCKPIT_FORMS_API_TOKEN = process.env.COCKPIT_FORMS_API_TOKEN;
export const WEBSITE_BASE_PATH = process.env.WEBSITE_BASE_PATH;
export const WEBSITE_SITE_ROOT = process.env.WEBSITE_SITE_ROOT;



// WEBPACK FOOTER //
// /Users/pauloamgomes/Sites/CockpitReactStatic/react-app/src/config.js